// Design tokens read directly out of the Figma frames via get_design_context
// (file VZsVkWxHidakz54xJ6sRZJ). Keep these literal — they are the source of
// truth for this feature and deliberately not re-derived from the global theme,
// which uses a different, older palette.
export const colors = {
  pageBg: '#FAFAFA',
  cardBg: '#FFFFFF',

  // Buttons / links use the brand purple; the ACTIVE TAB uses a darker purple.
  brand: '#9B59B6',
  activeTab: '#763099',

  text: '#0E0E0E',
  heading: '#000000',
  muted: '#64748B',
  backText: '#16161D',

  chipsPanelBg: '#F5EEF8',
  // Pending (not yet persisted) assignment highlight — "pastel yellow" in Figma.
  pendingBg: '#FDF3E6',

  chipBorder: '#D1D1D1',
  unassignedCardBorder: '#E5DAF6',
  journalCardBorder: '#D1D1D1',
  tabTrack: '#D9D9D9',
  bottomNavBorder: '#F5EEF8',
  disabled: '#D1D1D1',

  // "Included" / already-granted labelling on the purchase shelf.
  success: '#1F9254',
};

export const fonts = {
  heading: "'Bitter', serif",
  body: "'Poppins', sans-serif",
};

// Mobile frame is 412px wide with a 353px content column (≈29.5px gutters).
// Desktop cards are 330px on a max-3-column grid.
export const layout = {
  topNavHeight: 61,
  bottomNavHeight: 56,
  contentWidth: 353,
  desktopCardWidth: 330,
  desktopMaxWidth: 1140,
  modalWidth: 480,
  // Annotation on the design frame: the product-detail popover (Milestones, Watch
  // Me Grow, …) grows to a 590px modal with a 480px-wide image on desktop, rather
  // than scaling the mobile layout up.
  purchaseDetailModalWidth: 590,
  purchaseDetailImageWidth: 480,
};

// The project targets mobile-first; this is the single breakpoint where the
// dashboard switches to the desktop composition (top-right utility nav, card
// grid, inline footer) rather than scaling the mobile layout up.
export const DESKTOP = '@media (min-width: 900px)';
